import React, { useEffect, useState, useCallback } from "react";
import TagManager from "react-gtm-module";
import { parseCookies } from "nookies";

const WebAnalytics = () => {

  const [envProp, setEnvProp] = useState({});

  const fetchEnvPropJSON = useCallback(() => {
    fetch("/envprop.json")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setEnvProp(data);
      })
      .catch((error) => {
        console.log(error);
      });
  });

  useEffect(() => {
    fetchEnvPropJSON();
  }, []);

  const existCookies = parseCookies();

  const countryLang = existCookies.evCntryLang;
  let isAnalyticsEnabled = 1; // Enabled by default
  const euCookiePrefs = existCookies.EU_COOKIE_PREFS;

  if (euCookiePrefs && euCookiePrefs.toString()?.substring(0, 3)?.includes('0')) {
    isAnalyticsEnabled = 0;  
  }

  window.cookieCountries = 'HR|DE|AT|DK|FI|SE|NO|NL|BE|LU|IL|IS|UK|CH|FR|IT|BG|CY|CZ|EE|GR|HU|IE|LV|LT|MT|PL|PT|RO|SK|SI|ES|US';
  if(envProp?.cookie_countries){
    window.cookieCountries = envProp.cookie_countries;
    console.log("envProp cookieCountries: " + window.cookieCountries);
  }

  console.log("cookieCountries: " + window.cookieCountries);

  const cookieCountriesRegex = new RegExp(window.cookieCountries,'ig');

  // Include analytics scripts as per the preferences set for EU countries.
  if(countryLang &&
    (!(countryLang.substring(0,2).match(cookieCountriesRegex))
      || !(isAnalyticsEnabled == 0))) {
    // Google tag manager.
    if(envProp.react_app_gtm_container_id) {
      const gtmArgs = {
        gtmId: envProp.react_app_gtm_container_id,
      }
      TagManager.initialize(gtmArgs);
    }

    // Adobe Analytics.
    if(envProp?.react_app_adobe_launch_code) {
      const s = document.createElement('script');
      s.src = envProp.react_app_adobe_launch_code;
      s.async = true;
      const head = document.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(s);
      } else {
        console.error('error');
      }
    }
  }
};

export default WebAnalytics;